export default __webpack_public_path__ + "static/media/iconNavigator.b411ba02.png";